'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PROMISE_TIMEOUT_MS = exports.PROMISE_TIMEOUT_MS = 15000;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-pub-sub/static-1.4265/js/ably/constants/defaults.js
// module id = 141
// module chunks = 2 3